function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { makeObservable, observable, action } from "mobx";
import { PATH_GET_NEWS } from "@/config/news-config";
var NewsStore = /*#__PURE__*/function () {
  function NewsStore(rootStore) {
    _classCallCheck(this, NewsStore);
    _defineProperty(this, "rootStore", void 0);
    _defineProperty(this, "service", void 0);
    _defineProperty(this, "news", []);
    _defineProperty(this, "newsFetched", false);
    _defineProperty(this, "message", {
      id: "",
      show: false,
      text: "",
      type: ""
    });
    this.rootStore = rootStore;
    this.service = rootStore.service;

    // @ts-ignore
    makeObservable(this, {
      message: observable,
      newsFetched: observable,
      news: observable,
      fetchNews: action
    });
  }
  return _createClass(NewsStore, [{
    key: "fetchNews",
    value: function fetchNews(callback) {
      var _this = this;
      if (!this.newsFetched) {
        this.rootStore.uiStore.handleSpinner(++this.rootStore.uiStore.numberCallback);
        this.service.doAjax("GET", PATH_GET_NEWS).then(function (response) {
          if (response.status === 200) {
            _this.news = response.data;
            _this.newsFetched = true;
          }
          _this.rootStore.uiStore.handleSpinner(--_this.rootStore.uiStore.numberCallback);
          callback(response);
        }).catch(function (error) {
          if (error.response) {
            _this.rootStore.uiStore.handleSpinner(--_this.rootStore.uiStore.numberCallback);
            _this.rootStore.uiStore.addDangerMessage({
              "text": error.response.data
            });
          }
        });
      }
    }
  }]);
}();
export default NewsStore;